























































































import { EnumType, EnumOptions, Expression, Exprs } from 'expangine-runtime';
import { LiveRuntime } from 'expangine-runtime-live';
import { getConfirmation } from '../../../app/Confirm';
import { TypeUpdateEvent, TypeSettings } from '../TypeVisuals';
import { EnumSubs } from './EnumTypes';
import TypeEditorBase from '../TypeEditorBase';
import { Preferences, PreferenceCategory } from '../../../app/Preference';


const PREF_REMOVE_CONSTANT = Preferences.define({
  key: 'enum_remove_constant',
  label: 'Remove Enum constant without confirmation',
  category: [PreferenceCategory.DESIGN, PreferenceCategory.CONFIRM],
  defaultValue: false,
});


export default TypeEditorBase<EnumType, any, EnumSubs>().extend({
  name: 'EnumOptions',
  data: () => ({
    constants: [] as Array<[any, any]>,
  }),
  computed: {
    requiredKey() {
      return this.requiredType && this.requiredType instanceof EnumType
        ? this.requiredType.options.key
        : null;
    },
    requiredValue() {
      return this.requiredType && this.requiredType instanceof EnumType
        ? this.requiredType.options.value
        : null;
    },
  },
  watch: {
    'type.options.constants': {
      immediate: true,
      handler(value: Map<any, any>) {
        this.constants = Array.from(value.entries());
      },
    },
  },
  methods: {
    onChangeKey(event: TypeUpdateEvent) {
      this.type.options.key = event.type;
      this.$set(this.settings.sub, 'key', event.settings);

      if (event.transform) {
        const updateKeys = LiveRuntime.getCommand(
          this.type.getValueChangeExpression(event.transform, EnumType.STEP_KEY, EnumType.STEP_KEY),
        );
        
        this.type.options.constants = updateKeys({
          value: this.type.options.constants,
        });
      }
      
      this.update();
    },
    onChangeValue(event: TypeUpdateEvent) {
      this.type.options.value = event.type;
      this.$set(this.settings.sub, 'value', event.settings);

      let transform;
      if (event.transform) {
        const updateValues = LiveRuntime.getCommand(
          this.type.getValueChangeExpression(event.transform, EnumType.STEP_VALUE, EnumType.STEP_VALUE),
        );

        this.type.options.constants = updateValues({
          value: this.type.options.constants,
        });

        transform = event.transform;
      }

      this.change({ transform });
    },
    async removeConstant(index: number) {
      if (!await getConfirmation({ pref: PREF_REMOVE_CONSTANT })) {
        return;
      }
      
      this.constants.splice(index, 1);
      this.saveConstants();
    },
    addConstant() {
      const { key, value } = this.type.options;
      const { key: keySettings, value: valueSettings } = this.settings.sub as Record<EnumSubs, TypeSettings<any, any>>;

      this.constants.push([
        key.fromJson(keySettings.defaultValue),
        value.fromJson(valueSettings.defaultValue),
      ]);
      this.saveConstants();
    },
    setKey(index: number, value: any) {
      this.$set(this.constants[index], 0, value);
      this.saveConstants();
    },
    setValue(index: number, value: any) {
      this.$set(this.constants[index], 1, value);
      this.saveConstants();
    },
    saveConstants() {
      this.type.options.constants = new Map(this.constants);
      this.update();
    },
  },
});
